import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import TextSize from "../../utils/textSizeUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import theme from "../../utils/themeUtil";
import { Link } from "react-router-dom";
import FillButton from "../ui/fillButton";
import Routes from "../../utils/routesUtil";

function GoalSaving() {
    return (
        <React.Fragment>
            <Box bgcolor={theme.palette.lightWhite.main} py={isMobile ? 2 : 7.5}>
                <Box className={styles.container}>
                    <Box
                        bgcolor={theme.palette.white.main}
                        px={3}
                        pt={isMobile ? 2 : 8}
                        pb={isMobile ? 2 : 0}
                        style={{ borderRadius: "24px" }}
                    >
                        <Grid container spacing={2} alignItems="center">
                            <Grid
                                item
                                xs={12}
                                md={5}
                                style={{ textAlign: isMobile ? "center" : "left" }}
                            >
                                <img
                                    src={AppIcons.imgAppLoan}
                                    alt="Loan"
                                    width={isMobile ? "100%" : "auto"}
                                    className="wow animate__animated animate__zoomIn animate__slow"
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={7}
                                style={{ textAlign: isMobile ? "center" : "left" }}
                            >
                                <Box>
                                    <Typography
                                        style={{
                                            fontSize: isMobile ? TextSize.size22 : TextSize.size42,
                                            color: theme.palette.black.main,
                                            fontWeight: "600",
                                        }}
                                        className="wow animate__animated animate__fadeInUp animate__delay-0.9s animate__slow"
                                    >
                                        {Strings.takeCollateral}
                                    </Typography>
                                    <Box mt={2} className="wow animate__animated animate__fadeInUp animate__delay-0.6s animate__slow"
                                    >
                                        <Typography
                                            style={{
                                                fontSize: TextSize.size14,
                                                color: theme.palette.lightBlack.main,
                                            }}
                                        >
                                            {Strings.takeCollateralSubHeader}
                                        </Typography>
                                    </Box>
                                    <Box mt={3} className="wow animate__animated animate__fadeInUp animate__delay-0.6s animate__slow"
                                    >
                                        <Link to={Routes.MAHILA_LOAN}>
                                            <FillButton
                                                backgroundColor={theme.palette.primary.main}
                                                textColor={theme.palette.white.main}
                                                text={Strings.applyNow}
                                            />
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        bgcolor={theme.palette.white.main}
                        mt={isMobile ? 2 : 6.5}
                        px={3}
                        style={{ borderRadius: "24px", paddingTop: "50px" }}
                    >
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                                <img src={AppIcons.imgRocket} alt="Rocket" width="210" className="wow animate__animated animate__zoomIn animate__slow"
                                />
                                <Box mt={3}>
                                    <Typography
                                        style={{
                                            fontSize: isMobile ? TextSize.size24 : TextSize.size30,
                                            color: theme.palette.black.main,
                                            fontWeight: "600",
                                        }}
                                        className="wow animate__animated animate__fadeInUp animate__delay-0s animate__slow"
                                    >
                                        {Strings.superchargeYourBusiness}
                                    </Typography>
                                    <Box mt={2} className="wow animate__animated animate__fadeInUp animate__delay-0s animate__slow">
                                        <Typography
                                            style={{
                                                fontSize: TextSize.size14,
                                                color: theme.palette.black.main,
                                            }}
                                        >
                                            {Strings.superchargeYourBusinessSubHeader}
                                        </Typography>
                                    </Box>
                                    <Box mt={5} mb={isMobile ? 2 : 6}>
                                        <img
                                            src={AppIcons.imgGoalsSavings}
                                            alt="Goals Savings"
                                            width={isMobile ? "100%" : "auto"}
                                            className="wow animate__animated animate__zoomIn animate__slow"
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    );
}

export default GoalSaving;
